import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=5fa84c84&scoped=true"
import script from "./EditUser.js?vue&type=script&lang=js&external"
export * from "./EditUser.js?vue&type=script&lang=js&external"
import style0 from "./EditUser.scss?vue&type=style&index=0&id=5fa84c84&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa84c84",
  null
  
)

export default component.exports